import { render, staticRenderFns } from "./DeviceGroupTags.vue?vue&type=template&id=3445975f&scoped=true"
import script from "./DeviceGroupTags.vue?vue&type=script&lang=js"
export * from "./DeviceGroupTags.vue?vue&type=script&lang=js"
import style0 from "./DeviceGroupTags.vue?vue&type=style&index=0&id=3445975f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3445975f",
  null
  
)

export default component.exports